
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseItemsSelectDialog extends Serenity.TemplatedDialog<PurchaseItemsRow> {

        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }

        private serviceGrid = new PurchaseItemsSelectGrid(this.byId('serviceGrid'),[]);
        public form;

        constructor() {
            super();

            var tb = this.element.find('.s-DialogToolbar');
            this.element.append(tb);
            this.dialogTitle = "Select Products";
        }

        getToolbarButtons() {
            return [{
                title: 'ОК',
                cssClass: 'ok-button',
                onClick: () => this.okClick()
            }, {
                title: 'Cancel',
                cssClass: 'cancel-button',
                onClick: () => { this.dialogClose(); }
            }];
        }


        public okClick() {
          /*  var items = this.serviceGrid.selectedItems;
            this.element.trigger(<any>{
                type: 'okClick',
                selectedItems: items
            });
            return items;*/
        }
        public getdata() {
            var items = this.serviceGrid.selectedItems;
            this.element.trigger(<any>{
                type: 'okClick',
                selectedItems: items
            });
            return items;
        }

        protected getTemplate() {
            return (
                "<form id='~_Form' class='s-Form'>" +
                "<div id='~_serviceGrid'></div>" +
                "</form>" +
                "<div id='~_Toolbar' class='s-DialogToolbar' ></div>");
        }
    }

}